export const feedbackColumnData = [
  {
    label: "Hospital",
    value: "hospital_name",
    width: "250px",
  },
  {
    label: "Product",
    value: "applicationName",
    width: "280px",
  },
  {
    label: "Feedback Type",
    value: "exceptionType",
    removeSticky: true,
    width: "250px",
  },
  {
    label: "Feedback",
    value: "message",
    removeSticky: true,
    width: "500px",
  },
  {
    label: "Method",
    value: "method",
    removeSticky: true,
    width: "160px",
  },
  {
    label: "Request Url",
    value: "requestUrl",
    removeSticky: true,
    width: "160px",
  },
  {
    label: "User Name",
    value: "  ",
    removeSticky: true,
    width: "160px",
  },
  // {
  //   label: "Model",
  //   value: "model",
  //   removeSticky: true,
  //   width: "160px",
  // },

  // {
  //   label: "IP Address",
  //   value: "ipaddress",
  //   removeSticky: true,
  //   width: "160px",
  // },
  {
    label: "Date & Time",
    value: "createdDate",
    removeSticky: true,
    search: false,
    width: "160px",
  },
];
